import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'afs-nav',
  styleUrl: './afs-nav.sass',
  shadow: true,
})
export class AfsNav {

  @Prop() color : string = "#222222";

  render() {
    return (
      <ul style={{
          color: this.color,
        }}>
        <slot></slot>
      </ul>
    );
  }

}
